import { baixarArquivo } from '@/lib/http';
import { type PlanilhaFiscalQuery } from '@fiscoai/contracts';

/** Planilha fiscal (xlsx) — download autenticado; o nome vem do Content-Disposition. */
export function baixarPlanilhaFiscal(consulta: PlanilhaFiscalQuery) {
  return baixarArquivo(
    '/relatorios/planilha-fiscal.xlsx',
    `planilha-fiscal_${consulta.emitidaDe.slice(0, 7)}.xlsx`,
    { ...consulta },
  );
}
